"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var AllOrOne = function AllOrOne(props) {
  if (props.showAll) {
    return _react["default"].Children.toArray(props.children);
  }
  var renderedChildren = _react["default"].Children.toArray(props.children);
  return renderedChildren.length > 0 ? renderedChildren[0] : null;
};
AllOrOne.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]).isRequired,
  showAll: _propTypes["default"].bool
};
AllOrOne.defaultProps = {
  showAll: false
};
var _default = exports["default"] = AllOrOne;